import { useTranslation } from 'react-i18next';
import type { AccountRole } from '../account/AccountContext';
import { cn } from '../lib/cn';

/** The caller's role inside one line.
 *
 *  Owner is the quiet case — it is the default expectation and needs no emphasis. The
 *  delegate roles are tinted, because "I am only a viewer here" is the fact that
 *  explains a missing button. */
const TONE: Record<AccountRole, string> = {
  OWNER: 'bg-muted text-muted-foreground',
  ADMIN: 'bg-violet-500/15 text-violet-600 dark:text-violet-400',
  RESPONDER: 'bg-sky-500/15 text-sky-600 dark:text-sky-400',
  VIEWER: 'bg-amber-500/15 text-amber-600 dark:text-amber-400',
};

export function RoleBadge({ role, className }: { role: AccountRole; className?: string }) {
  const { t } = useTranslation();
  return (
    <span
      className={cn(
        'shrink-0 rounded px-1.5 py-0.5 text-[11px] font-medium leading-tight',
        TONE[role],
        className,
      )}
    >
      {t(`accountRole.${role}`)}
    </span>
  );
}
